import React from "react";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../../shared/layout/ColorInit";
import Order from "../components/Order";
import Header from "../../../shared/layout/Header";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";

const OrderTrack = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />
      <Header />
      <div className="container container-lg">
        <Order />
      </div>
      <Footer />

      <BottomFooter />
    </CartProvider>
  );
};
export default OrderTrack;
